var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieChartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99867 17.1667H9.99917C11.4272 17.1672 12.8228 16.7411 14.0069 15.9431C15.0968 15.2085 15.9619 14.1898 16.5102 13.0001H17.2377C16.0604 15.838 13.2625 17.8334 9.99935 17.8334C5.67299 17.8334 2.16602 14.3264 2.16602 10.0001C2.16602 6.73689 4.1614 3.93907 6.99935 2.76174V3.49049C5.59931 4.13788 4.44233 5.22128 3.70476 6.58286C2.9131 8.04429 2.65381 9.73538 2.97127 11.3669C3.28872 12.9984 4.16317 14.4688 5.44505 15.5268C6.72693 16.5848 8.33659 17.1645 9.99867 17.1667ZM10.8953 2.88902L10.3327 2.81796V3.38508V9.16675V9.66675H10.8327H16.6143H17.1815L17.1104 9.1041C16.911 7.52534 16.1921 6.05777 15.0669 4.93256C13.9417 3.80734 12.4741 3.08841 10.8953 2.88902ZM9.99935 2.16675C14.3257 2.16675 17.8327 5.67372 17.8327 10.0001C17.8327 10.112 17.8304 10.2231 17.8257 10.3334H9.66602V2.17372C9.77637 2.16907 9.88748 2.16675 9.99935 2.16675Z",
    fill: "#1F2937",
    stroke: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChartIcon);
export default __webpack_public_path__ + "static/media/pie-chart-icon.e06cc48f941f4475b21a7161fd668265.svg";
export { ForwardRef as ReactComponent };